import React from 'react';
import { BarChart } from '../../../../ui-components/data-viz-ui/charts/bar-chart/BarChart';
import { TimePeriodUnsegmentedBarChartUiComponentProps } from './types';

export const TimePeriodUnsegmentedBarChartUiComponent = (
  props: TimePeriodUnsegmentedBarChartUiComponentProps
) => {
  return <BarChart {...props} />;
};
